import { useTranslation } from 'react-i18next'
import { Button } from '@material-tailwind/react'
import { FiPlus } from 'react-icons/fi'

export const CreateButton = () => {
  const { t } = useTranslation()

  return (
    <Button className='flex justify-center items-center gap-2'>
      <FiPlus size='1rem' />
      {t('actions.create.one')}
    </Button>
  )
}
